"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VNumericFieldRounded = void 0;
var mobx_react_1 = require("mobx-react");
var react_1 = __importStar(require("react"));
var lodash_1 = require("lodash");
var core_1 = require("@blueprintjs/core");
var style_1 = require("./style");
var FormFieldContainer_1 = require("./FormFieldContainer");
var Validators_1 = require("../Validators");
exports.VNumericFieldRounded = (0, mobx_react_1.observer)(function (props) {
    var _a;
    var label = props.label, labelInfo = props.labelInfo, fieldState = props.fieldState, leftIcon = props.leftIcon, size = props.size, disabled = props.disabled, inline = props.inline, placeholder = props.placeholder, id = props.id, fill = props.fill, className = props.className, layer = props.layer, noLabel = props.noLabel, required = props.required, validators = props.validators, margin = props.margin, tipLabel = props.tipLabel, tooltip = props.tooltip, displayRequired = props.displayRequired, autoComplete = props.autoComplete, maxDecimals = props.maxDecimals, roundTo = props.roundTo, noFillWithZero = props.noFillWithZero;
    var _b = (0, react_1.useState)(''), state = _b[0], setState = _b[1];
    var _c = (0, react_1.useState)(false), focused = _c[0], setFocused = _c[1];
    (0, react_1.useEffect)(function () {
        var propsValue = getValue();
        var newValue = ((0, lodash_1.isNumber)(propsValue) &&
            props.roundTo &&
            fillWithZero(propsValue, roundTo, !!noFillWithZero)) ||
            propsValue;
        setState(newValue);
    }, [roundTo]);
    (0, react_1.useEffect)(function () {
        if (fieldState) {
            if (required) {
                if (validators && validators.length > 0) {
                    fieldState.validators.apply(fieldState, __spreadArray([Validators_1.Validators.required], validators, false));
                }
                else {
                    fieldState.validators(Validators_1.Validators.required);
                }
            }
            else if (validators && validators.length > 0 && fieldState.validators) {
                fieldState.validators.apply(fieldState, validators);
            }
        }
    }, [required, validators]);
    (0, react_1.useEffect)(function () {
        var value = getValue();
        if (value !== parseToNumber(state)) {
            if (!focused) {
                MaskValue();
            }
            else if (!String(state).endsWith('.')) {
                setState(value);
            }
        }
    }, [(_a = props === null || props === void 0 ? void 0 : props.fieldState) === null || _a === void 0 ? void 0 : _a.value, props === null || props === void 0 ? void 0 : props.value]);
    var getValue = function () {
        if (props.fieldState) {
            return parseToNumber(props.fieldState.value);
        }
        return parseToNumber(props.value);
    };
    var parseToNumber = function (value) {
        var parsedValue = parseFloat(value);
        return (0, lodash_1.isNumber)(parsedValue) && (0, lodash_1.isFinite)(parsedValue) ? parsedValue : '';
    };
    var calculeMask = function (value) {
        var val = (0, lodash_1.cloneDeep)(value);
        if ((0, lodash_1.isNumber)(val) && (0, lodash_1.isFinite)(val) && roundTo) {
            val = (0, lodash_1.round)(Number(val.toString()), roundTo);
        }
        val = fillWithZero(val, roundTo || 0, !!noFillWithZero);
        return val;
    };
    var MaskValue = function () {
        var _a;
        var val = getValue();
        val = calculeMask(val);
        setState(val);
        (_a = props.onBlur) === null || _a === void 0 ? void 0 : _a.call(props);
    };
    var onChange = function (e) {
        var value = convertValidValue(e.target.value);
        if (!!value && regExp.test(value)) {
            if (!!maxDecimals) {
                if (canAddDecimalPlace(value, maxDecimals)) {
                    setState(value);
                    setPropsValues(value);
                }
                else {
                    var newValue = value;
                    if (!!roundTo &&
                        "".concat(value) &&
                        !"".concat(value).endsWith('.') &&
                        (0, lodash_1.isNumber)(Number(value)) &&
                        (0, lodash_1.isFinite)(Number(value))) {
                        newValue =
                            "".concat(newValue && (0, lodash_1.round)(Number(newValue.toString()), roundTo)) ||
                                '';
                        setState(newValue);
                        setPropsValues(newValue);
                    }
                }
            }
            else if ((!maxDecimals && regExpNoDecimalPlace.test(value)) ||
                !value ||
                (Number(value) === 0 && "".concat(value).length === 1)) {
                setState(value);
                setPropsValues(value);
            }
        }
        else if (!value) {
            setState(value);
            setPropsValues(value);
        }
    };
    var setPropsValues = function (val) {
        if (props.fieldState && props.fieldState.onChange) {
            props.fieldState.onChange(parseToNumber(val));
        }
        if (props.onChange) {
            props.onChange(parseToNumber(val));
        }
    };
    var onFocus = function (event) {
        var _a;
        (_a = props === null || props === void 0 ? void 0 : props.onFocus) === null || _a === void 0 ? void 0 : _a.call(props, event);
        setFocused(true);
    };
    var onBlur = function () {
        setFocused(false);
        MaskValue();
    };
    var onPaste = function (e) {
        var _a;
        var oldValue = e && e.currentTarget && e.currentTarget.value;
        var newValue = e && e.clipboardData && e.clipboardData.getData('Text');
        (_a = props === null || props === void 0 ? void 0 : props.onPaste) === null || _a === void 0 ? void 0 : _a.call(props, oldValue, newValue);
    };
    return (react_1.default.createElement(style_1.StyledNumericInput, { className: className, disabled: disabled, inline: inline, intent: fieldState && fieldState.hasError ? core_1.Intent.DANGER : core_1.Intent.NONE, labelFor: id, labelInfo: labelInfo, layer: layer, fill: fill, noLabel: noLabel, margin: margin },
        react_1.default.createElement(FormFieldContainer_1.FormFieldContainer, { required: required || displayRequired, noLabel: noLabel, label: label, fieldState: fieldState, tooltip: tooltip },
            tipLabel && react_1.default.createElement("span", { className: 'tipLabel' }, tipLabel),
            react_1.default.createElement(core_1.InputGroup, __assign({ name: id, large: size === 'large' }, {
                disabled: disabled,
                placeholder: placeholder,
                id: id,
                leftIcon: leftIcon,
                fill: fill
            }, { autoComplete: autoComplete ? autoComplete : 'no_auto', onChange: onChange, value: state !== null && state !== void 0 ? state : '', intent: fieldState && fieldState.hasError ? core_1.Intent.DANGER : core_1.Intent.NONE }, { onPaste: onPaste, onFocus: onFocus, onBlur: onBlur })))));
});
var fillWithZero = function (value, round, noFillWithZero) {
    if (!(0, lodash_1.isNumber)(value)) {
        return '';
    }
    if (round === 0 || noFillWithZero) {
        return value;
    }
    var values = "".concat(value || '').split('.');
    if (values && values.length === 2) {
        var secValues_1 = "".concat(values[1]);
        while (secValues_1.length < round) {
            secValues_1 += "0";
        }
        return "".concat(values[0], ".").concat(secValues_1);
    }
    var secValues = "";
    while (secValues.length < round) {
        secValues += "0";
    }
    return value || "".concat(value).toString() ? "".concat(value, ".").concat(secValues) : '';
};
var canAddDecimalPlace = function (value, round) {
    var values = "".concat(value || '').split('.');
    if (values && values.length === 2) {
        var secondValue = values[1];
        return !secondValue.length || secondValue.length <= round;
    }
    return true;
};
var startsWithZero = function (value) {
    if (value) {
        var values = "".concat(value || '').split('.');
        if (values.length === 2) {
            var num = values[1];
            if (regExp.test(num)) {
                return "0.".concat(num);
            }
        }
    }
};
var convertValidValue = function (value) {
    if (!!value) {
        if (value.startsWith('.')) {
            return startsWithZero(value);
        }
        if (value.startsWith('-.')) {
            return "-".concat(startsWithZero(value));
        }
    }
    return value;
};
var regExp = /^(-)?[0-9]*([.][0-9]*)?$/;
var regExpNoDecimalPlace = /^(-)?([0-9]*)?$/;
